let pixels = {};

const state = {
  insertion: "fm",
};

function fire(key) {
  const url = pixels[key];
  if (!url) return;
  const fullUrl = url;
  console.log(`[tracking] ${key} →`, fullUrl);
  const img = new Image();
  img.referrerPolicy = "no-referrer-when-downgrade";
  img.decoding = "async";
  img.src = fullUrl;
}

// --- Public API ---
export const initTracking = (cfg) => {
  pixels = cfg?.pixels || {};
  state.insertion = cfg?.insertion || state.insertion;
};

export const tapOnAr = () => {
  // Teads
  fire("tap-on-ar");
  console.log("Tap on AR");
};

export const cameraActivated = () => {
  // Teads
  fire("camera-activated");
  console.log("Camera activated");
};

export const modelLoaded = (modelColor) => {
  // Teads
  fire("3d-model-loaded");
  console.log("3D model loaded");
};

export const interactionWithModel = (modelColor) => {
  // Teads
  fire("interaction-3d-model");
  console.log("Interaction 3D Model");
};

export const tapOn3D = () => {
  // Teads
  fire("tap-on-3d");
  console.log("Tap on 3D");
};
